export class Microsoft365User {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "userId",
            "baseName": "userId",
            "type": "string",
            "format": ""
        },
        {
            "name": "userPrincipalName",
            "baseName": "userPrincipalName",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "mail",
            "baseName": "mail",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountEnabled",
            "baseName": "accountEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "hasMailbox",
            "baseName": "hasMailbox",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "hasOnedrive",
            "baseName": "hasOnedrive",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "mailboxType",
            "baseName": "mailboxType",
            "type": "string",
            "format": ""
        },
        {
            "name": "licenseStatus",
            "baseName": "licenseStatus",
            "type": "Microsoft365UserLicenseStatus",
            "format": ""
        },
        {
            "name": "licenses",
            "baseName": "licenses",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365User.attributeTypeMap;
    }
    constructor() {
    }
}
